// THIS FILE IS AUTOGENERATED - EDITS WILL BE OVERWRITTEN
import { Injectable } from "@angular/core";
import { V2ApiService } from "../bases/v2-api.service";
import { Guid } from "../models/ApiTypes";
import { DtoContactPointShortForm } from "../models/DtoContactPointShortForm";
import { DtoContactPointsActivate } from "../models/DtoContactPointsActivate";
import { DtoContactPointCreate } from "../models/DtoContactPointCreate";
import { DtoContactPointUpdate } from "../models/DtoContactPointUpdate";

@Injectable({providedIn: 'root'})
export class ContactPointsApiService {
    private readonly controller = "ContactPoints";

    constructor(private v2Api: V2ApiService) { }

    /** Activates a contact point without requiring user authentication.
     * @param contactPointID 
     * @param activationCode 
     */
    publicActivate(contactPointID: Guid, activationCode: string) {
        return this.v2Api.post<void>(this.controller, "PublicActivate", { contactPointID, activationCode });
    }

    /** Gets all Contact Points associated with Current User.
     */
    getByCurrentUser() {
        return this.v2Api.get<DtoContactPointShortForm[]>(this.controller, "GetByCurrentUser", {  });
    }

    /** Activates a specific contact point.
     * @param body 
     */
    activate(body: DtoContactPointsActivate) {
        return this.v2Api.post<DtoContactPointShortForm>(this.controller, "Activate", {  }, body);
    }

    /** Resend activation code for a specific contact point.
     * @param contactPointID 
     */
    resend(contactPointID: Guid) {
        return this.v2Api.post<void>(this.controller, "Resend", { contactPointID });
    }

    /** Creates a contact point for current user.
     * @param body 
     */
    create(body: DtoContactPointCreate) {
        return this.v2Api.post<DtoContactPointShortForm>(this.controller, "Create", {  }, body);
    }

    /** Update one of the current user's contact points.
     * @param body 
     */
    update(body: DtoContactPointUpdate) {
        return this.v2Api.post<DtoContactPointShortForm>(this.controller, "Update", {  }, body);
    }

    /** Deletes a specific contact point owned by the current user.
     * @param contactPointID 
     */
    delete(contactPointID: Guid) {
        return this.v2Api.post<void>(this.controller, "Delete", { contactPointID });
    }
}